import { ReclamationType } from 'graphql-ts-types';

import type { TrackingEventType } from 'common/enums/Reclamation';

const EVENT_TYPE = {
  [ReclamationType.Cancellations]: 'cancellation',
  [ReclamationType.ReturnsAndComplaints]: 'claim',
};

export const getTrackingEventType = (
  reclamationType: ReclamationType,
  reclamationItemsLength: number = 0
) => {
  if (reclamationItemsLength <= 0) {
    return null;
  }

  return `${EVENT_TYPE[reclamationType]}_${
    reclamationItemsLength === 1 ? 'single' : 'multiple'
  }` as TrackingEventType;
};
